import "./DeleteAccountConfirmation.css";

const DeleteAccountConfirmation = ({
  isOpen,
  onClose,
  onConfirm,
  deleting = false,
  error = null,
}) => {
  if (!isOpen) return null;

  return (
    <div className="delete-account-modal-overlay" onClick={onClose}>
      <div
        className="delete-account-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="delete-account-modal-icon">
          <i className="ph ph-warning" />
        </div>
        <h3 className="delete-account-modal-title">Delete Account</h3>
        <p className="delete-account-modal-text">
          Are you sure you want to delete your account? This action cannot be
          undone.
        </p>
        {error && (
          <div className="delete-account-modal-error">{error}</div>
        )}
        <div className="delete-account-modal-actions">
          <button
            className="delete-account-modal-btn delete-account-modal-btn-cancel"
            onClick={onClose}
            disabled={deleting}
          >
            Cancel
          </button>
          <button
            className="delete-account-modal-btn delete-account-modal-btn-confirm"
            onClick={onConfirm}
            disabled={deleting}
          >
            {deleting ? "Deleting..." : "Delete Account"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountConfirmation;